import React from 'react';
import { StyledSvg, iconGenerator } from '../Icon';
const TryBlockIcon = ({ size }) => (React.createElement(StyledSvg, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", size: size },
    React.createElement("g", { fill: "none", fillRule: "evenodd", transform: "translate(1.5 2.5)" },
        React.createElement("rect", { width: "17", height: "15", stroke: "#FFF", strokeWidth: "1.3", rx: "1.8" }),
        React.createElement("text", { fill: "#FFF", fontFamily: "ProximaNova-Black, Proxima Nova", fontSize: "6.5", fontWeight: "700" },
            React.createElement("tspan", { x: "2", y: "10" }, "TRY")))));
export const TryBlock = iconGenerator(TryBlockIcon);
//# sourceMappingURL=TryBlock.js.map